export const TYPE = {
  SET: 'set',
  ITEM: 'item',
  COLOR: 'color',
  PROJECT: 'project',
  IMAGE: 'image',
  QUERY: 'query',
};

export const FILTER_KEYS = {
  PAGE: 'page',
  PER_PAGE: 'limit',
  HAS_MORE: 'hasMore',
  SORT_DIRECTION: 'orderBy',
  CATEGORIES: 'category',
  MANUFACTURERS: 'manufacturer',
  TYPE: 'type',
  STORAGE: 'storage',
  QUANTITY: 'count',
  ITEMS: 'items',
  TAGS: 'tags',
  COLORS: 'colors',
  QUERY: 'query',
  // SORT_BY: 'orderBy',
};

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
  MOST_LIKED: 'like_level',
  NAME: 'itemName',
  CATEGORY: 'category',
  MANUFACTURER: 'manufacturer',
  STORAGE: 'storage',
};

export const SEARCH_QUERY_KEYS = {
  ITEMS: 'items',
  TAGS: 'tags',
  COLORS: 'color',
  QUERY: 'query',
};
